



















import Vue from 'vue';
import * as api from '@/api';

export default Vue.extend({
    data() {
        return {
            news: [] as api.NewsItem[],
        };
    },
    props: ['unreadCount'],
    watch: {
        unreadCount() {
            this.getSitMessages();
        },
    },
    methods: {
        toUserNews() {
            if (this.$route.name !== 'News') this.$router.replace('/user/news');
        },
        toNews(id) {
            this.toUserNews();
            this.$store.commit('lookNewsId', id);
        },
        async getSitMessages() {
            const res = await api.getSitMessages({
                Status: 0,
                SkipCount: 0,
                MaxResultCount: 5,
                Category: '',
            });
            if (!api.error(res)) {
                res.data.items.forEach((e) => {
                    if (e.content) {
                        e.content = e.content.replace(/<img[^>]+>/g, '*[图片]*').replace(/<[^>]+>/g, '');
                        if (e.content.length > 50) {
                            e.content = `${e.content.slice(0, 50)}...`;
                        }
                    }
                });
                this.news = res.data.items;
            }
        },
         async readNew(item) {
            await api.readMessages({ id: item.id });
            // this.$store.commit('currentProductInfo', item.extData);
            this.$router.push({ path: `/product/${item.extData.productId}` });
            this.$store.dispatch('getUnreadCount');
        },
    },
    mounted() {
        this.getSitMessages();
    },
});

